class MFRTimedCarousel {
  constructor(i, e, options) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      items: "> *",
      pageDots: ".flickity-page-dots",
      bar: ".flickity-page-dots .dot.is-selected",
      allBars: ".flickity-page-dots .dot",
      playPause: ".play-pause-button",
      nextButton: ".next-button",
    };

    this.flickityOptions = options.flickityOptions;
    this.autoplayTiming = options.autoplayTiming;
    this.extras = options.extras;
    this.playPauseHTML = options.playPauseHTML;

    this.timingArgs = {
      percentTime: 0,
      isPaused: false,
    };

    this.lastSlide = false;
    this.allowFullProgress = true; /// if true, each dot wont reset when going to next slide

    this.init();
  }

  init() {
    this.$slider = this.$element;
    this.$item = this.$element.find(this.selectors.items);
    this.$currentSlide = this.$element.find(this.selectors.currentSlide);

    this.initCarousel();
    window.onWidthResize(() => {
      if (this.$element.data("flickity"))
        // this.$element.flickity("destroy");
        this.initCarousel();
    });
  }

  initCarousel() {
    if (this.$item.length <= 1) return;
    this.$slider.flickity({
      ...this.flickityOptions,
      on: {
        change: (i,e) => {
          if (this.allowFullProgress) {
            if (i == 0) this.lastSlide = true;
            else {
              this.lastSlide = false;
              this.$element.find(this.selectors.allBars).each((index, dot) => {
                if (index < i) {
                  $(dot).css({
                    "--dynamic-width": 100 + "%",
                  });
                }
                if (index > i) {
                  $(dot).css({
                    "--dynamic-width": 0 + "%",
                  });
                }
              });
            }
          }

          this.resetProgressbar();
          this.updateSlideIndicators();
          this.startProgressbar();
        },
        ready: () => {
          if (this.extras) {
            const pausePlayLI = $(`<li class="controls"></li>`).append(
              $(this.playPauseHTML)
            );
            const navLI = $(`<li class="controls"></li>`).append(
              `<button class="${this.selectors.nextButton.replace('.','')}" aria-label="next"></button>`
            );

            this.$slider
              .find(this.selectors.pageDots)
              .addClass("has-controls")
              .prepend(pausePlayLI)
              .append(navLI);

            this.$element
              .find(this.selectors.playPause)
              .on("click", this.__handlePlayPauseClick.bind(this));
            this.$element
              .find(this.selectors.nextButton)
              .on("click", this.__handleNextButtonClick.bind(this));
          }
          setTimeout( () => {
            this.$slider.flickity("resize");
          }, 1);
        },
      },
    });

    this.$slider.addClass("timed-carousel");

    this.updateSlideIndicators();
    this.startProgressbar();
  }

  updateSlideIndicators() {
    const flkty = this.$slider.data("flickity");
    const currentSlideNumber = flkty.selectedIndex + 1;
    this.$allBars = this.$element.find(this.selectors.allBars);

    this.$currentSlide.text(currentSlideNumber);
  }

  startProgressbar() {
    this.resetProgressbar();
    this.timingArgs.percentTime = 0;
    // this.timingArgs.isPaused = false;
    // this.timingArgs.tick = setInterval(this.interval.bind(this), 10);
    this.timingArgs.lastTimestamp = performance.now();
    this.timingArgs.tick = requestAnimationFrame(this.interval.bind(this));
  }

  interval(timestamp) {
    if (!this.timingArgs.isPaused) {
      this.timingArgs.percentTime +=
        (timestamp - this.timingArgs.lastTimestamp) /
        (this.autoplayTiming * 1000); // Convert to seconds
      this.timingArgs.lastTimestamp = timestamp;

      if (this.timingArgs.percentTime >= 1) {
        this.$slider.flickity("next", true);
        this.startProgressbar();
      } else {
        this.$element.find(this.selectors.bar).css({
          "--dynamic-width":
            (this.timingArgs.percentTime * 100).toFixed(2) + "%",
        });
        this.timingArgs.tick = requestAnimationFrame(this.interval.bind(this));
      }
    } else {
      this.timingArgs.lastTimestamp = performance.now();
      this.$element.find(this.selectors.bar).css({
        "--dynamic-width": (this.timingArgs.percentTime * 100).toFixed(2) + "%",
      });
      this.timingArgs.tick = requestAnimationFrame(this.interval.bind(this));
    }
  }

  resetProgressbar() {
    if (this.allowFullProgress) {
      if (this.lastSlide) {
        this.$allBars.css({
          "--dynamic-width": 0 + "%",
        });
      }
    }
    else {
      this.$allBars.css({
        "--dynamic-width": 0 + "%",
      });
    }
    // clearTimeout(this.timingArgs.tick);
    cancelAnimationFrame(this.timingArgs.tick);
  }

  __handlePlayPauseClick(e) {
    this.timingArgs.isPaused = this.$element
      .find(this.selectors.playPause)
      .hasClass("pause");
  }

  __handleNextButtonClick(e) {
    this.$slider.flickity( "next" );
  }
}